import type { ExtraItemsProps } from "./ExtraItems.decl";

export function ItemsList({ items }: ExtraItemsProps) {
  return (
    <div>
      {items.map((item, index) => (
        <p
          key={item.id.toString() + index.toString()}
          className="capitalize truncate"
        >
          {item.text}
        </p>
      ))}
    </div>
  );
}
